import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 504,
  name: 'Gateway Timeout',
  description:
    'The server acting as a gateway or proxy did not receive a timely response from the upstream server. The proxy waited for the backend to respond but the request took longer than the configured timeout.',
  causes: [
    'The upstream application server is too slow — a heavy database query, external API call, or CPU-intensive operation exceeded the proxy timeout.',
    'Network latency or connectivity issues between the proxy and upstream server. Packets are being delayed or dropped.',
    'The upstream server is deadlocked, stuck in an infinite loop, or blocked on I/O, preventing it from responding at all.',
  ],
  fixes: [
    'Identify and optimize the slow operation. Check for unindexed database queries, N+1 query patterns, or slow external API calls that should be made asynchronous.',
    'Increase the proxy timeout as a temporary fix: proxy_read_timeout in nginx, timeout in HAProxy. But address the root cause — raising timeouts masks performance problems.',
    'Add request timeouts to external API calls in your application code. Use circuit breakers to fail fast instead of hanging when a dependency is slow.',
  ],
  monitoringTip:
    'A 504 means your app is too slow for the proxy layer. Uptrack tracks response times alongside status codes, so you can spot latency degradation before it escalates into full 504 timeouts.',
}

export const Route = createFileRoute('/_site/http/504')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
